/** Only application entity links get special navigation while editing. */
export function isEntityLink(href: string, origin: string): boolean {
  try {
    const url = new URL(href, origin);
    return url.origin === origin && /^\/(?:i\/[0-9a-f-]{36}\/)?[^/]+\/(?:doc\/[0-9a-f-]{36}|task\/[0-9a-f-]{36}|issue\/[a-z0-9]+-\d+)$/i.test(url.pathname);
  } catch {
    return false;
  }
}
